import {v4} from "uuid";
import {AppParty, AppQuestion, AppViewQuestion, IsQuestionGroup} from "../types/types";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";

export const populateParty = (party: AppParty) => {
    const populateQuestion = (question: AppQuestion | AppViewQuestion, groupId?: number, groupOrder?: number) => {
        if ((question.allowMultiple && (question.questionType === 1 || question.questionType === 4) || question.questionType === 8) && (!question.answers || question.answers.length === 0)) {
            question.answers = [{
                text: "",
                id: v4(),
                questionId: question.id,
                groupId: groupId,
                order: 0,
                groupOrder: groupOrder ?? 0,
                attachments: [],
                status: StatusUpdateAnswer.NONE,
                errorText: "",
            }];
        }
        return question;
    }

    return {
        ...party,
        presets: party.presets.map(preset => ({
            ...preset,
            items: preset.items.map(item => {
                if (IsQuestionGroup(item)) {
                    return {
                        ...item,
                        views: item.views.map(view => ({
                            ...view,
                            questions: view.questions.map(question => populateQuestion(question, item.id, view.order))
                        }))
                    };
                } else {
                    return populateQuestion(item, undefined, undefined) as AppQuestion;
                }
            })
        }))
    } as AppParty;
}

export const getQuestion = (source: AppParty, questionId: number, groupId?: number, groupOrder?: number): AppQuestion | AppViewQuestion | undefined => {
    if (!source) return undefined;
    if (groupId && (groupOrder !== undefined)) {
        const questionGroup = source.presets
            .flatMap(preset => preset.items)
            .find(item => item.id === groupId && IsQuestionGroup(item));
        if (!questionGroup || !IsQuestionGroup(questionGroup)) return undefined;
        return questionGroup.views
            .find(v => v.order === groupOrder)?.questions
            ?.find(q => q.id === questionId) as AppViewQuestion;
    }

    return source.presets
        .flatMap(preset => preset.items)
        .find(item => item.id === questionId) as AppQuestion;
};